import { Button } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { tKeys } from 'locales';
import { useTranslation } from 'locales/logic';

export const DeleteButton = (
  props: React.ComponentProps<typeof Button> & React.HTMLAttributes<HTMLButtonElement>,
) => {
  const { t } = useTranslation();

  return (
    <Button leftSection={<IconTrash stroke={1.5} size={18} />} color="error" {...props}>
      {t(tKeys.DELETE)}
    </Button>
  );
};
